// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"484":"84ba4388","603":"e8cdb7f1","621":"879e38a8"}[chunkId] + ".chunk.css";
};